// disOS session state. One source of truth for "who is signed in", loaded once on app start.
import { create } from 'zustand';
import { authApi, type AuthUser } from '../api/client';

export type AuthStatus = 'loading' | 'authed' | 'anon';

interface AuthState {
  status: AuthStatus;
  user: AuthUser | null;
  /** Resolve the current session from the cookie (called once at startup). */
  load(): Promise<void>;
  login(email: string, password: string): Promise<void>;
  signup(email: string, password: string): Promise<void>;
  logout(): Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  status: 'loading',
  user: null,
  async load() {
    try {
      const user = await authApi.me();
      set(user ? { status: 'authed', user } : { status: 'anon', user: null });
    } catch {
      set({ status: 'anon', user: null });
    }
  },
  async login(email, password) {
    const user = await authApi.login(email, password);
    set({ status: 'authed', user });
  },
  async signup(email, password) {
    const user = await authApi.signup(email, password);
    set({ status: 'authed', user });
  },
  async logout() {
    try { await authApi.logout(); } finally { set({ status: 'anon', user: null }); }
  },
}));
